var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Navbar'),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-9"},[(_vm.$store.state.isMobileScreen)?_c('BetslipButton'):_vm._e(),_c('router-view')],1),_c('div',{staticClass:"col-12 col-md-3"},[_c('RightBar')],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }